import { PRICING_TIER_OPTIONS } from '@/shared/constants/instantCall';
import {
  InstantEventType,
  Pricing,
  PricingTier,
} from '@/shared/types/generated';
import { formatCurrency } from '@/shared/utils';

type TierOption = { label: string; value: PricingTier };

export const buildPricingTierOptions = (
  pricingData: Pricing[],
): TierOption[] => {
  // Map tierName → hourlyRate (in cents)
  const rateMap = pricingData.reduce<Record<string, number>>((acc, p) => {
    acc[p.tierName] = p.hourlyRate;
    return acc;
  }, {});

  return PRICING_TIER_OPTIONS.map(({ value, label }) => {
    const cents = rateMap[value as string] ?? 0;
    const money = formatCurrency(cents);

    return {
      value,
      label: `${label} - ${money}/Hr`,
    };
  });
};

export const getHourlyRateFromPricingRequest = (
  tier: PricingTier,
  pricingData: Pricing[],
) => {
  const found = pricingData.find((p) => p.tierName === tier);
  return found?.hourlyRate ?? 0;
};

export const getDurationFromInstantEventType = (
  eventType: InstantEventType,
) => {
  switch (eventType) {
    case InstantEventType.SixtyMinutes:
      return 60;
    case InstantEventType.FortyFiveMinutes:
      return 45;
    case InstantEventType.ThirtyMinutes:
      return 30;
    case InstantEventType.FifteenMinutes:
      return 15;
    default:
      return 60; // Should not be reached
  }
};

export const getTimeRemainingInSeconds = (expiresAt: Date | null) => {
  if (!expiresAt) {
    return 0;
  }

  const now = new Date();
  const timeRemaining = Math.floor(
    (expiresAt.getTime() - now.getTime()) / 1000,
  );

  return Math.max(timeRemaining, 0);
};
